<template>
  <div class="float-dialog mini-float-dialog" ref="myDialog" @dblclick="maxim">
    <div class="title color-dark border-bottom">
      <slot name="title"></slot>
      <i @click="close" style="padding:12px 10px 10px 4px;float:right;cursor: pointer;" class="el-icon-close"></i>
      <i @click="maxim" style="padding:12px 4px 10px 20px;float:right;cursor: pointer;" class="el-icon-copy-document"></i>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  mounted(){

  },
  methods:{
    close(){
      this.$emit('close')
    },
    maxim(){
      this.$emit('maxim')
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-float-dialog{
  overflow: hidden;
  cursor: pointer;
  float:right;
  margin-right:10px;
  .title{
    height:40px;
    padding-left:10px;
    line-height: 40px;
  }
}
</style>